import { useEffect } from 'react';
import registry from '../../seo/seoRegistry.json';
import { brandTitle } from '../../seo/seoCore';

export const siteUrl = () => (process.env.REACT_APP_SITE_URL || window.location.origin).replace(/\/+$/, '');

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) { el?.remove(); return; }
  if (!el) { el = document.createElement('meta'); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute('content', content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"][data-cms]`);
  if (!href) { el?.remove(); return; }
  if (!el) { el = document.createElement('link'); el.setAttribute('rel', rel); el.setAttribute('data-cms', '1'); document.head.appendChild(el); }
  el.setAttribute('href', href);
};

// Applies page SEO settings to <head>. Pass seo from the CMS page.
export const useSeoHead = (seo, { path, fallbackTitle } = {}) => {
  useEffect(() => {
    if (!seo) return;
    const title = brandTitle(seo.title || fallbackTitle);
    if (title) document.title = title;
    setMeta('name', 'description', seo.meta_description);
    setMeta('name', 'keywords', seo.meta_keywords);
    setMeta('name', 'robots', seo.no_index ? (seo.no_follow ? 'noindex, nofollow' : 'noindex, follow') : (seo.no_follow ? 'nofollow' : null));
    setMeta('property', 'og:title', brandTitle(seo.og_title) || title);
    setMeta('property', 'og:description', seo.og_description || seo.meta_description);
    const img = seo.og_image || registry.site.default_image;
    const ogImage = img && img.startsWith('/') ? `${siteUrl()}${img}` : img; // social scrapers need absolute URLs
    setMeta('property', 'og:image', ogImage);
    setMeta('name', 'twitter:image', ogImage);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:url', seo.canonical_url || (path ? `${siteUrl()}${path}` : window.location.href));
    setMeta('name', 'twitter:card', ogImage ? 'summary_large_image' : 'summary');
    setMeta('name', 'twitter:title', brandTitle(seo.og_title) || title);
    setMeta('name', 'twitter:description', seo.og_description || seo.meta_description);
    setLink('canonical', seo.canonical_url || (path ? `${siteUrl()}${path}` : null));
    let ld = document.head.querySelector('script[data-cms-ld]');
    if (seo.schema_markup) {
      if (!ld) { ld = document.createElement('script'); ld.type = 'application/ld+json'; ld.setAttribute('data-cms-ld', '1'); document.head.appendChild(ld); }
      ld.textContent = (typeof seo.schema_markup === 'string' ? seo.schema_markup : JSON.stringify(seo.schema_markup)).replace(/\{\{site_url\}\}/g, siteUrl());
    } else ld?.remove();
  }, [seo, path, fallbackTitle]);
};

export const SeoHead = ({ seo, path, fallbackTitle }) => { useSeoHead(seo, { path, fallbackTitle }); return null; };
